import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, inject, effect, ViewChild,ViewChildren, QueryList, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModule, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@services/core/user.service';
import { BudgetGenerateService } from '@services/budget-generate.service';
import { Entity } from '@model/entity.model';
import Swal from 'sweetalert2'
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { LOCALE_ID } from '@angular/core';
import { NumberFormatDirective } from 'app/directives/number-format.directive';
import { Parser } from 'expr-eval';
import { SettingFieldSalaryCalculatedComponent } from './setting-field/setting-field-salary-calculated.component';
import { BudgetOverViewComponent } from '../../budget-over-view/budget-over-view.component';
import { FilterModel } from './filter.model';

import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-employee-salary-calculated',
  standalone: true,
  imports: [DecimalPipe, NgSelectModule, FormsModule, NumberFormatDirective, SettingFieldSalaryCalculatedComponent, NgbModule, CommonModule, BudgetOverViewComponent],
  providers: [NgbModal, { provide: LOCALE_ID, useValue: 'es-ES' }],
  templateUrl: './employee-salary-calculated.component.html',
  styleUrl: './employee-salary-calculated.component.css'
})
export class EmployeeSalaryCalculatedComponent {
  @ViewChild('modal_account', { static: true }) modalAccount: any;
  @ViewChild('modal_setting', { static: true }) modalSetting: any;
   @ViewChildren(NgbPopover) popovers!: QueryList<NgbPopover>;
    
  @ViewChild('tableData', { static: true }) tableData!: ElementRef;
  private modalRef: NgbModalRef;
  private userService = inject(UserService);
  public dataDepartament;
  public ngSelectedOld: string;
  public inputOld;

  public subtotal:{ [key: string]: any };
  private entitySelected: Entity;
  public codeEntity;
  public budgetService = inject(BudgetGenerateService)

  public filterByEmployeeType: { [key: string]: any[] } = {};
  public datalistEmployee: { [key: string]: any[] } = {};
  public itemsAccount: { [key: string]: any[] } = {};
  public itemsAccountTemp: { [key: string]: any[] } = {};
  public Employee: { [key: string]: any[] } = {};
  public EmployeeTemp: { [key: string]: any[] } = {};


  public filter: FilterModel = new FilterModel();
  public navTab = 'dependientes'
  public rows =Array.from({length: 15}, (_, i) => i + 1);
  public cols =Array.from({length: 5}, (_, i) => i + 1);
  public isLoading = true;
  public activeDependent=false
  public activeIndependent=false
  public isActiveConfig=false
  public employeeType;
  public title='Presupuesto'
  public items;
  public itemsTemp;
  public dataEmployeeType;
  public budgetVersionSelected;
  public budgetEmployeeType;
  public fundSelect;
  public budgetFund;
  public budgetStatus;
  public categoryFormula;
  public categorySelect=[];

  pendingUpdates: any[] = [];
  updateTimer: any = null;
  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';




  constructor(private modalService: NgbModal

  ) {


  
      effect(() => {
        let entitySelected = this.userService.sharingEntity();
        this.budgetVersionSelected = this.userService.sharingBudgetVersion()
        const employeeTypesData = this.userService.sharingEmployeeType();
        const budgetFundData = this.userService.sharingBudgetFund();
        this.budgetEmployeeType = employeeTypesData || [];
        if (this.budgetEmployeeType.length > 0) {
          this.entitySelected = entitySelected;
          this.filter.year = this.budgetVersionSelected.year;
          this.filter.version = this.budgetVersionSelected.version;
          this.budgetStatus = this.budgetVersionSelected.status;
            this.employeeType = this.budgetEmployeeType[0].employeeType;
            this.budgetFund = budgetFundData;         
            this.fundSelect = budgetFundData[0].fundCode;
            this.title=this.budgetEmployeeType[0].employeeTypeName;
            this.getEmployeeSalaryCalculated();
            this.getItemsAccount();
            this.getResumen()
            this.getCategoryFormula()
        } 
    });



  }


  ngOnInit() {

  }


  getCategoryFormula() {
    this.budgetService.getCategoryFormula().subscribe(res => {
      this.categoryFormula = res;
    })
  }



  //negative
negative(event: KeyboardEvent){
  const charCode = event.which ? event.which : event.keyCode;
}


coditionalNegativeSymbol(input){
  return input.value.includes('-') || input.selectionStart !== 0
}

setCharCode(event){
  return event.which ? event.which : event.keyCode;
}
  onlyNumber(event: KeyboardEvent) {
    const charCode = this.setCharCode(event)
    const input = event.target as HTMLInputElement;
    if (
      [8, 9, 37, 39, 46, 48,49,50,51,52,53,54,55,56,57].includes(charCode)
    ) {
      return;
    }
  
    // Permitir el signo negativo solo al inicio
    if (charCode === 45) {
      if (this.coditionalNegativeSymbol(input)) {
        event.preventDefault();
      }
      return;
    }
  
  }
  
   
  
  tabChange(employeeType) {
    this.employeeType=employeeType.employeeType;
    this.title=employeeType.employeeTypeName;
    this.changeFund(this.fundSelect);
    this.changeNgSelectFilter(this.employeeType)
  }

  openAccountConfig() {
    this.isActiveConfig = true;
  }

  openModalAccount() {
    this.open(this.modalAccount, { size: 'xl' })
  }

  openModalSetting() {
    this.open(this.modalSetting)
  }

  /*abre los modales */
  open(content, size?) {
    this.modalRef = this.modalService.open(content, size);
  }

  /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  getResumen(){
    this.budgetService.getResumen(this.filter).subscribe(res => {
      this.itemsTemp = JSON.parse(JSON.stringify(res));
      this.items = res;
      this.changeFund(this.fundSelect);
    })
  }

  /**Selecciona todo el texto del input */
  selectAll(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    inputElement.select();
  }


  notification(title) {
    const Toast = Swal.mixin({
      icon: 'success',
      title: title,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
    Toast.fire();
  }



  changeSetting(){
            this.getEmployeeSalaryCalculated();
            this.getItemsAccount();
            this.getResumen()
            this.getCategoryFormula()
  }


  updateValueAccounts(employee, code, value) {
    value = value.replace(/\./g, '').replace('.', ',');
      const item = this.setEmployeeItem(employee, code);
      item.value = value
      this.budgetService.updateEmployeeSalaryCalculated({ id: item?.id, value: value }).subscribe(res => {
        this.getResumen();
        this.notification('Actualizado');
      })
  }




  // Divide la fórmula en sus componentes, incluyendo códigos, variables, números y operadores.
  splitFormula(formula) {
    try {
      const regex = /(\{\d+\}|\{\w+\}|\d+(?:\.\d+)?|\+|\-|\*|\/|\(|\))/g;
      return formula.match(regex).filter(Boolean);
    } catch {
      return [];
    }
  }

  
  findEmployeeItemToltipValue(employeeItems, code) {
    if (Array.isArray(employeeItems)) {
      return employeeItems.find(i => i.code == code) || null;
    }
    return null;
  }

  // Busca el valor de una cuenta específica dentro del array de cuentas de un empleado.  
  findEmployeeItemValue(employeeItems, code) {
   let value = 0;
    if (Array.isArray(employeeItems)) {
      let item = employeeItems.find(i => i.code == code);
      if (item) {
        value = item.value;
      }
    }
    return value
  }

  // Reemplaza los códigos en la fórmula por sus valores correspondientes del array de cuentas del empleado.
  replaceCodesWithValues(formulaArray, employeeItems) {
    return formulaArray.map(item => {
      const match = item.match(/^\{([\w-]+)\}$/);
      let value = item
      if (match) {// Si el item es un código en el formato {código}, busca el valor      
        const code = match[1]; // Extrae el código numérico        
        value = this.findEmployeeItemValue(employeeItems, code);
      }
      return value;
    });
  }

  replacePercentSyntax(formulaArray) {
    return formulaArray.map(item =>
      item.endsWith('%')
        ? (parseFloat(item.slice(0, -1)) / 100).toString()
        : item
    );
  }

  /**evaluamos q las formulas no tengan ningun script *//** Elimina palabras peligrosas de una fórmula */
  isSafeFormula(formula) {
    const unsafeKeywords = ['alert', 'eval', 'console', 'document', 'window', 'setTimeout', 'setInterval'];
    unsafeKeywords.forEach(keyword => {
      const regex = new RegExp(keyword, 'gi'); 
      formula = formula.replace(regex, '');
    });
    return formula;
  }

  // Convierte el array de la fórmula en una cadena y la evalúa para obtener el resultado final.
  executeCalculation(formulaArray) {
    const parser = new Parser();
    const formulaString = formulaArray.join(' ');
    let cleanFormula = formulaString.replace(/,/g, '.').trim();
     try {
     let result = parser.evaluate(cleanFormula);
     result = Number.isFinite(result) ? Math.round(result) : 0;
     return result;
    } catch (error) {
      return 0;
    }
  }

  /** */
  updateValueCalculated(employee, code, valueNew, employeeType) {
    let valueOld = this.findEmployeeItemValue(employee.items, code);
  
    if (valueNew != undefined && valueNew != valueOld) {
      const item = this.setEmployeeItem(employee, code);
      if (item) {
        item.value = valueNew;
        this.pendingUpdates.push({ id: item.id, value: valueNew });
        if (!this.updateTimer) {
          this.updateTimer = setTimeout(() => {
            this.flushUpdates();
          }, 1000); 
        }
      }
    }
  }
  
  flushUpdates() {
    if (this.pendingUpdates.length > 0) {
      const updates = [...this.pendingUpdates]; 
      this.pendingUpdates = []; 
      this.updateTimer = null;
      this.budgetService.bulkUpdateEmployeeSalaryCalculated(updates)
        .subscribe(res => {
        });
    }
  }
  


  setEmployeeItem(employee, code) {
    return employee.items?.find(i => i.code == code);
  }



  //realiza el cálculo.
  calculation(employee, itemCode, item, employeeType) {
    const conditional=this.parseConditional(item.calculation)
    if (conditional) {

      let resultCalculation =this.executeConditional(conditional, employee.items)
           this.updateValueCalculated(employee, itemCode, resultCalculation, employeeType)
    }
    else {
      const formulaArray = this.splitFormula(item.calculation);
      const formulaWithValues = this.replaceCodesWithValues(formulaArray, employee.items);
      let resultCalculation = this.executeCalculation(formulaWithValues);
      this.updateValueCalculated(employee, itemCode, resultCalculation, employeeType)
    }
  }

  
// Detecta  si exite condicional if(condición; true; false) puede procesar if anidados
parseConditional(formula) {
  const regex = /if\(([^;]+);(.+);(.+)\)/;
  const match = formula.match(regex);
  let condicional = null;

  if (match) {
    const condition = match[1].trim();
    let ifTrue = match[2].trim();
    let ifFalse = match[3].trim();

    // Verificar si ifTrue contiene otro "if" anidado
    let hasNestedIf = false; // Inicializamos en falso

    // Verificamos si hay "if" anidados en ifTrue
    if (this.isNestedIf(ifTrue)) {
      ifTrue = this.parseConditional(ifTrue); // Procesamos el if anidado recursivamente
      hasNestedIf = true;
    }

    // Verificamos si hay "if" anidados en ifFalse
    if (this.isNestedIf(ifFalse)) {
      ifFalse = this.parseConditional(ifFalse); // Procesamos el if anidado recursivamente
      hasNestedIf = true;
    }

    // Crear la estructura del "if"
    condicional = {
      condition,
      ifTrue,
      ifFalse,
      hasNestedIf
    };
  }

  return condicional; // Devuelve null si no es un "if" válido
}

// Función para verificar si un string tiene un "if" anidado
isNestedIf(str) {
  const nestedIfRegex = /if\(([^;]+);(.+);(.+)\)/;
  return nestedIfRegex.test(str);
}



/**remplaza el codigo por su valor */
  replaceConditionalCodesWithValues(condition, employeeItems){
    return  condition?.replace(/\{(\d+)\}/g, (_, code) => {
      return this.findEmployeeItemValue(employeeItems, code);
    });
  }


/**evalua el condicional y determina si es true o false */
  evaluateCondition(condition, employeeItems) {
    const conditionWithValues=this.replaceConditionalCodesWithValues(condition, employeeItems)
    try {
      return eval(conditionWithValues); 
    } catch {
      return false; 
    }
  }

  /**ejecutamos la formula segun sea el caso */
  executeConditional(parsedConditional, employeeItems) {
  const { condition, ifTrue, ifFalse, hasNestedIf } = parsedConditional;

  // Evaluamos la condición principal
  const conditionResult = this.evaluateCondition(condition, employeeItems);

  // Determinamos la fórmula a ejecutar (si es ifTrue o ifFalse)
  let selectedFormula = conditionResult ? ifTrue : ifFalse;
  // Si el "if" tiene un "if" anidado, procesamos recursivamente
  if (hasNestedIf) {
      return selectedFormula = this.executeConditional(selectedFormula, employeeItems);
  }
  const formulaArray = this.splitFormula(selectedFormula);
  const formulaWithValues = this.replaceCodesWithValues(formulaArray, employeeItems);
  let resultCalculation = this.executeCalculation(formulaWithValues);
  return resultCalculation;
}

  /** dejamos solo las cuentas que depende de fmr*/
  accountDeleteConst(employee) {
    const employeeCopy = [...
      employee.items.filter(account => account.fmrApplied === true)]
    return employeeCopy
  }


  syncEmployee(){
    Swal.fire({
          icon: 'warning',
          title: 'Alerta ',
          text: '¿Desea sincronizar los valores de APS? se actualizaran todos los conceptos configurados con la opcion de importacion APS' ,
          toast: false,
          position: 'center',
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
          timer: null,
          timerProgressBar: false
        }).then((result) => {
          if (result.isConfirmed) {
            const filter = {
    year: this.filter.year,
    version: this.filter.version
  };
  this.budgetService.syncApsEmployeeAccount({ year: this.filter.year }).subscribe((res)=>{
     
    this.budgetService.syncApsValue(filter).subscribe((res)=>{
         this.getEmployeeSalaryCalculated();
        Swal.close();
        this.notification('Datos actualizados');
      })
    })
    
          }
        })
  
  }


  // Obtiene el valor de una cuenta
  getAccountValue(employee, code, item, employeeType) {
    if (item?.calculation&&this.budgetStatus==2) {
      this.calculation(employee, code, item, employeeType)
    }
    return this.findEmployeeItemValue(employee.items, code);
  }

    getValueToltip(employee, code, item, employeeType) {
   
    return this.findEmployeeItemToltipValue(employee.items, code);
  }

  hasReference(employee, item) {
    if (!item?.apsCode) return false;
    const ref = this.getValueToltip(employee, item.code, item, employee.typeId);
    if (!ref) return false;
    return Number(ref.avgValue || 0) > 0
      || Number(ref.expenseValue || 0) > 0
      || Number(ref.projectionValue || 0) > 0;
  }


  // Obtiene el valor de una cuenta
  getSubtotalValue(code, employeeType) {
    const typeSubtotal = this.subtotal?.[employeeType];
    if (!typeSubtotal) return '';
  
    const account = typeSubtotal[code];
    return account ?? '';
  }

  /**trae los datos de la asigancion de viaje */
  getEmployeeSalaryCalculated() {
    this.loading();
    this.budgetService.getEmployeeSalaryCalculated(this.filter).subscribe(res => {
      this.budgetEmployeeType.forEach(b => {
        const list = res.filter(r => r.employeeType== b.employeeType);
        
        this.Employee[b.employeeType] = list;
        this.EmployeeTemp[b.employeeType] = JSON.parse(JSON.stringify(list));
        this.datalistEmployee[b.employeeType] = this.ngSelectDiverse(list); 
      })
      this.isLoading =false;
      
      this.changeFund(this.fundSelect);
      Swal.close()
    })
  }


  buildSubtotal() {
    this.subtotal = {};
  
    this.budgetEmployeeType?.forEach(b => {
      const employees = this.Employee[b.employeeType] ?? [];
  
      const summary = {};
      employees?.forEach(emp => {
        this.calculatedSubtotal(emp, summary);
       
      });
  
      this.subtotal[b.employeeType] = summary;
    });
  }


calculatedSubtotal(emp, summary) {
  emp.items.forEach(item => {
    if (item.includeInTotal) {
      if (!summary[item.code]) summary[item.code] = 0;
      summary[item.code] += Number(item.value) ?? 0;
    }
  });
}
  
  

  
      /*filtra los datos por fund*/

      changeFund(fundCode) {
        this.fundSelect=fundCode;
        if(this.EmployeeTemp[this.employeeType]){ 
            if(this.filterByEmployeeType[this.employeeType]?.length>0){
              this.Employee[this.employeeType] = this.EmployeeTemp[this.employeeType].filter(d => 
              d.fundCode==this.fundSelect);
            }
            else{
              this.Employee[this.employeeType] = this.EmployeeTemp[this.employeeType].filter(d => 
              d.fundCode==this.fundSelect
              );
            }
        
       this.datalistEmployee[this.employeeType] = this.ngSelectDiverse(this.Employee[this.employeeType]);
        this.changeFundPlan();
        this.changeFundResumen();
        this.changeNgSelectFilter(this.employeeType);   

      }
    }


    
  changeFundResumen() {
    if(this.itemsTemp){
      Object.keys(this.itemsTemp).forEach(key => {
        const arr = this.itemsTemp[key];
        
        if (Array.isArray(arr) && arr.length > 0 && 'fundCode' in arr[0]) {
          this.items[key] = arr.filter(item => item.fundCode == this.fundSelect);
        }
      });
    }
   this.items={...this.items}
  }

    changeFundPlan() {     
      this.changeNgSelectFilterCategory(this.employeeType);
    }

 changeNgSelectFilterCategory(employeeType) {
    if(this.categorySelect.length != 0){
     this.itemsAccount[employeeType]=this.itemsAccountTemp[employeeType]?.filter(
      item =>item.fundCode==this.fundSelect && this.categorySelect.includes(item.categoryCode));
    }
    else{
      this.itemsAccount[employeeType]=this.itemsAccountTemp[employeeType]?.filter(d => 
        d.fundCode==this.fundSelect
      );
    }

  }


   /*mensaje de cargando */
   loading() {
    Swal.fire({
      title: 'Cargando...',
      html: 'Por favor, espere',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }


  /*al momento de dar un click almacena el valor anterior del input en otra funcion se compara el valor nuevo con el anterior */
  toggleInput(value) {
    this.inputOld = value.replace(/\./g, '').replace('.', ',');
  }


  /*mapea los datos del ng-select */
  ngSelectDiverse(diverse) {
    let newData = diverse.map((d) => {
      return {
        diverse: d.employeeCode,
        nameDiverse: d.employeeCode + ' - ' + d.employeeNames,
        name: d.employeeNames
      }
    });
    return newData
  }


    /**al momento de cerrar el ng select de busqueda busca actualiza la tabla de diversos  */
changeNgSelectFilter(employeeType) {
  const filters = this.filterByEmployeeType[employeeType];

  if (!filters || filters.length === 0) {
    this.Employee[employeeType] = this.EmployeeTemp[employeeType];
  } else {
    this.Employee[employeeType] = this.EmployeeTemp[employeeType].filter(d => 
      filters.includes(d.employeeCode)
    );
  }

  this.buildSubtotal();
}





  /**trae el plan de cuentas */
  getItemsAccount() {  
    this.budgetService.getSalaryCalculatedItems(this.filter).subscribe(res => {
      this.budgetEmployeeType.forEach(b => {
        this.itemsAccountTemp[b.employeeType] = res?.filter(r => r?.employeeType == b?.employeeType);
        this.itemsAccount[b.employeeType] = JSON.parse(JSON.stringify(this.itemsAccountTemp[b.employeeType]));
        this.changeFund(this.fundSelect);
      })
    })
  }


    headers(typeId){
      let headers = [   
        'N° Diverso',
        'Nombre Empleado',
        'Año',
        'Versión'
      ];
      const accountPlan=this.dataAccounts(typeId);
      return [...headers,...this.headerAccounts(accountPlan)]
    }
  
    headerAccounts(accountPlan){
          return accountPlan?.map(acc=>
            acc.name
      )
    }
  
    styleHeaderRow(worksheet, rowNumber: number): void {
      const headerRow = worksheet.getRow(rowNumber);
      worksheet.getRow(rowNumber).height = 25;
      headerRow.eachCell(cell => {
        cell.font = { bold: true };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFBFBFBF' } // gris claro
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = {
          top: { style: 'medium' },
          bottom: { style: 'medium' },
          left: { style: 'medium' },
          right: { style: 'medium' }
        };
      });
    }
  
    styleDataRow(row, accountStartIndex): void {
      row.eachCell((cell, colNumber) => {
        // Aplicar bordes a todas las celdas
        cell.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'medium' },
          right: { style: 'medium' }
        };
    
        // Si la columna es una cuenta, aplicar formato numérico
        if (colNumber >= accountStartIndex) {
          cell.numFmt = '#,##0';
        }
      });
    }
  
  
    autoAdjustColumns(worksheet): void {
      worksheet.columns.forEach(column => {
        let max = 10;
        column.eachCell({ includeEmpty: true }, cell => {
          const len = cell.value ? cell.value.toString().length : 10;
          if (len > max) max = len;
        });
        column.width = max + 2;
      });
    }  

    
styleSubtotalRows(worksheet, rowNumber: number): void {
  const subtotalRow = worksheet.getRow(rowNumber);
  subtotalRow.height = 25;
  subtotalRow.eachCell(cell => {
    cell.font = { bold: true };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFBFBFBF' } // gris claro
    };
    cell.alignment = { vertical: 'middle', horizontal: 'right' };
    cell.border = {
      top: { style: 'medium' },
      bottom: { style: 'medium' },
      left: { style: 'medium' },
      right: { style: 'medium' }
    };
    cell.numFmt = '#,##0';
  });
}

addSubtotalRow(worksheet,startCol,rowNumber,mergeCol): void {
  const lastRowNumber = worksheet.lastRow.number;
  const subtotalRow = worksheet.addRow([]);
  if (mergeCol >= 1) {
    worksheet.mergeCells(subtotalRow.number, 1, subtotalRow.number, mergeCol);
    const labelCell = worksheet.getCell(subtotalRow.number, 1);
    labelCell.value = 'SUBTOTAL';
    labelCell.alignment = { horizontal: 'center', vertical: 'middle' };
    labelCell.font = { bold: true };
  }
  for (let col = startCol; col <= worksheet.columnCount; col++) {
    const colLetter = worksheet.getColumn(col).letter;
    const cell = subtotalRow.getCell(col);
    cell.value = {
      formula: `SUM(${colLetter}${rowNumber}:${colLetter}${lastRowNumber})`,
      result: null
    };
    cell.font = { bold: true };
  }
}  
  
  
    createSheet(workbook: Workbook, title, headers, data, accounts) {
      const totalColumns = 4 + accounts.length;
      const worksheet = workbook.addWorksheet(title);
    
      // Título
      worksheet.mergeCells(1, 1, 1, totalColumns);
      const titleCell = worksheet.getCell('A1');
      titleCell.value = `VIAJES ${title.toUpperCase()}`;
      titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
      titleCell.font = { bold: true };
      worksheet.getRow(1).height = 40;
      for (let col = 1; col <= totalColumns; col++) {
        worksheet.getCell(1, col).border = {
          top: { style: 'medium' },
          left: { style: 'medium' },
          bottom: { style: 'medium' },
          right: { style: 'medium' },
        };
      }
    
      // Encabezados: nombres de cuentas
     
      // Encabezado principal
      worksheet.addRow(headers);
      this.styleHeaderRow(worksheet, 2);
      // Datos
      data.forEach(obj => {
        const row = worksheet.addRow(Object.values(obj));
        this.styleDataRow(row, 5);
      });
      this.addSubtotalRow(worksheet,5,3,4);
      this.styleSubtotalRows(worksheet, worksheet.lastRow.number);
    
      this.autoAdjustColumns(worksheet);
    }


    dataAccounts(typeId){
      if(this.categorySelect.length==0){
        return this.itemsAccountTemp[typeId];
      }
      return this.itemsAccountTemp[typeId].filter(items=> this.categorySelect.includes(items.categoryCode))
    }

    
  
   
  exportToExcel(): void {
    const workbook = new Workbook();
  
    for (let b of this.budgetEmployeeType) {
      const employeeType = b.employeeType;
      const data = this.Employee[employeeType];
      const accounts = this.dataAccounts(employeeType);
      const headers = this.headers(b.employeeType);
      const sheetTitle = b.employeeTypeName;
  
      const formattedData = this.dataExcel(data, accounts);
      this.createSheet(workbook, sheetTitle, headers, formattedData, accounts);
    }
  
    // Solo se ejecuta una vez al final
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      this.saveExcelFile(blob, 'calculos_' + this.getDate());
    });
  }
  
  
    dataExcel(data,plan) {

      const result = data?.map(e => {
        const fixedDataValues = [  
          e.employeeCode,
          e.employeeNames,  
          e.year,
          e.version,
        ];  
        const accountsData = this.flattenAccounts(e.items);
        const accountsValues = plan.map(code => accountsData[code.code] ?? 0);  
        const result2 = [...fixedDataValues, ...accountsValues];
        return result2
      });
      return result;
    }
    
    flattenAccounts(accounts) {
      const accountMap = {};
      for (const acc of accounts) {
        accountMap[acc.code.toString()] = Number(acc.value) ?? 0; 
      }
      return accountMap;
    }
    
  
    private saveExcelFile(buffer: any, fileName: string): void {
      const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
      saveAs(data, `${fileName}.xlsx`);
    }

    
    /**Obtener la fecha en formato 04/12/2024 09:36:44  */
    getDate() {
      let date = new Date();
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' } as const; // Opciones para la fecha
      const formattedDate = date.toLocaleDateString('es-ES', options); // Formato DD-MM-YYYY
      const formattedTime = date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' }); // Formato HH:mm:ss
      return `${formattedDate}_${formattedTime}`;
    }


 }
